import React from 'react'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft, ArrowRight, ArrowSkip } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { FollowerGrowthGraph } from 'screens/blaze/Home/VirtualMarketerHome/WelcomeBack/FollowerGrowthGraph'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { StickyFooter, FooterButtons } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'
import Styles from './FollowerGrowthExplainer.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface FollowerGrowthExplainerProps {
  onNext: () => void
  onBack: () => void
}

export const AutopilotSidebar = () => {
  return (
    <div className={Styles.sidebarContainer}>
      <div className={Styles.sidebarContent}>
        <div className={Styles.sidebarSection}>
          <Heading level={5}>Why Integrate?</Heading>
          <div className={Styles.sidebarText}>
            <div className={Styles.bulletItem}>
              <span>•</span>
              <span>Get AI-generated insights to grow your account.</span>
            </div>
            <div className={Styles.bulletItem}>
              <span>•</span>
              <span>
                Save 5+ hours per week through automatic posting. All posts auto-schedule by default—review, edit, or
                delete anytime.
              </span>
            </div>
          </div>
        </div>

        <div className={Styles.sidebarSection}>
          <Heading level={5}>Connection issues?</Heading>
          <div className={Styles.sidebarText}>
            Our support team resolves 95% of issues in under 3 minutes via the help button below.
          </div>
        </div>

        <div className={Styles.supportButton}>
          <SupportChat />
        </div>
      </div>
    </div>
  )
}

export const FollowerGrowthExplainer = ({ onNext, onBack }: FollowerGrowthExplainerProps) => {
  const { isMobile } = useResponsiveDesign()
  const [hasIntegration, setHasIntegration] = React.useState(false)

  return (
    <MultiStepStepLayout
      title="💥 Blaze can get you to YY in 6 months."
      scrollContainerClassName={Styles.scrollContainer}
    >
      <StickyFooterProvider
        footer={
          <StickyFooter>
            <FooterButtons>
              <ResponsiveDesign.Desktop>
                <Button variant="tertiary" size="xl" onPress={onBack} frontIcon={ArrowLeft} aria-label="Back">
                  Back
                </Button>
              </ResponsiveDesign.Desktop>
              <div className={Styles.rightButtonGroup}>
                {!hasIntegration && (
                  <Button
                    variant="tertiary"
                    size="xl"
                    onPress={onNext}
                    endIcon={ArrowSkip}
                    aria-label="Skip"
                    fullWidth={isMobile}
                  >
                    Skip
                  </Button>
                )}
                <Button
                  size="xl"
                  onPress={onNext}
                  endIcon={ArrowRight}
                  aria-label="Let's make this happen"
                  fullWidth={isMobile}
                  isDisabled={!hasIntegration}
                >
                  Let&apos;s make this happen
                </Button>
              </div>
            </FooterButtons>
          </StickyFooter>
        }
      >
        <div className={Styles.container}>
          <FollowerGrowthGraph onIntegrationStatusChange={setHasIntegration} />
        </div>
      </StickyFooterProvider>
    </MultiStepStepLayout>
  )
}
